import { Category } from '@modules/common/types';

export const STEPS_LABEL = [
  {
    label: 'Describe this Reason',
  },
  {
    label: 'Review Matching Feedback',
  },
  {
    label: 'Review Reason',
  },
] as const;

export const ADD_FEEDBACK_INPUT_TRANSITION_DURATION = 400;

export const REASON_DESCRIPTION_GUIDE = [
  {
    reasonName: 'Issue With Downloading Videos On Mac',
    description: `Feedback where users are experiencing problems or are unhappy with the process of downloading videos 
    when on a Mac system, often detailing specific issues such as error messages, slow download speeds, videos not saving correctly, 
    or the system's compatibility with the video download feature.`,
    category: Category.Complaint,
  },
  {
    reasonName: 'Help With Payment Not Going Through',
    description: `Feedback where users have experienced difficulties or issues with payment processing. 
    This include declined transactions, payment errors, or trouble with entering payment details on the website or app. 
    Customers often seek assistance or clarification on why their payment did not go through successfully.`,
    category: Category.Help,
  },
  {
    reasonName: 'Happy with Uploading Images',
    description: `Feedback where users express satisfaction, contentment and positive experiences specifically related to 
    the feature that allows them to upload images. Comments highlight and appreciate the wide range of supported image formats 
    or the quality and compatibility of the uploaded images with the service's functionality.`,
    category: Category.Praise,
  },
  {
    reasonName: 'Ability To Upload Longer Videos To Platform',
    description: `Feedback where users have discussed, requested, or commented on the capability to upload longer-duration videos 
    to the platform. This includes suggestions to extend the current video length limits, or inquiries about how one can upload 
    videos that exceed the current duration restrictions. This limitation hampers users' ability to share in-depth tutorials, 
    detailed presentations, or present their work.`,
    category: Category.Improvement,
  },
] as const;
